import React from 'react';
import { rotateRect90deg } from 'pxc-editor-core/helpers/calculation';
import SectionBarcodeComponent from './Barcode';
import SectionImageComponent from './Image';
import SectionGlyphComponent from './Glyph';
import SectionTextComponent from './Text';
import SectionShapeComponent from './Shape';

const SectionContent = (props) => {
  const { sectionId, rectProps, formatProps, resizeType } = props;
  const { x, y, width, height } = rectProps;
  const { angle, mirrorX, mirrorY, code, image, glyph, text, shape } = formatProps;

  let corrProps = rectProps;
  let corrMirX = mirrorX;
  let corrMirY = mirrorY;
  if (angle === 90 || angle === 270) {
    corrProps = rotateRect90deg(x, y, width, height);
    const oldMirX = corrMirX;
    corrMirX = corrMirY;
    corrMirY = oldMirX;
  }

  let transformStr = '';
  if (corrMirX) {
    transformStr = `${transformStr} scale(-1, 1) translate(-${corrProps.x * 2 + corrProps.width}, 0)`;
  }
  if (corrMirY) {
    transformStr = `${transformStr} scale(1, -1) translate(0, -${corrProps.y * 2 + corrProps.height})`;
  }
  if (angle) {
    transformStr = `${transformStr} rotate(${angle} ${x + width / 2} ${y + height / 2})`;
  }

  return (
    <g transform={transformStr}>
      {code && <SectionBarcodeComponent formatProps={formatProps} rectProps={corrProps} id={`${sectionId}-code`} />}
      {image && <SectionImageComponent formatProps={formatProps} rectProps={corrProps} id={`${sectionId}-image`} image={image} />}
      {glyph && <SectionGlyphComponent formatProps={formatProps} rectProps={corrProps} id={`${sectionId}-glyph`} />}
      {shape && <SectionShapeComponent formatProps={formatProps} rectProps={corrProps} id={`${sectionId}-shape`} />}
      {!code && !glyph && !image && text && (
        <SectionTextComponent
          formatProps={formatProps}
          rectProps={corrProps}
          id={`${sectionId}-text`}
          sectionId={sectionId}
          resizeType={resizeType}
        />
      )}
    </g>
  );
};

export default SectionContent;
